// src/pages/Troubleshooting.js
import React, { useEffect } from 'react';
import Layout from '../components/Layout';
import translations from '../translations';
import { useMeta } from '../useMeta';

function Troubleshooting({ language = 'en' }) {
  const t = translations[language] || translations['en'];
  const prefix = language === 'en' ? '' : `/${language}`;

  useMeta({
    title: `${t.troubleshooting.title} | ERC Unlock`,
    description: language === 'en'
      ? 'Toyota ERC unlock not working? Troubleshoot common issues: wrong code entered, unsupported model, service mode not accessible, and more.'
      : undefined,
    canonical: `https://ercunlock.com${prefix}/troubleshooting`
  });

  useEffect(() => {
    document.documentElement.lang = language;
    document.documentElement.dir = language === 'ur' ? 'rtl' : 'ltr';
    document.title = `${t.troubleshooting.title} | ERC Unlock`;
  }, [language, t.troubleshooting.title]);

  return (
    <Layout language={language}>
      <div className="content-card">
        <h1>{t.troubleshooting.title}</h1>
        <div className="prose">
          <p>{t.troubleshooting.intro}</p>
          {t.troubleshooting.items.map((item, i) => (
            <div key={i}>
              <h2>{item.problem}</h2>
              <p>{item.solution}</p>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
}

export default Troubleshooting;
